module.exports = __webpack_public_path__ + "media/images/flags/16/Red-Cross-d02fd49ea1f4f76477cc63ac1aabd424.png";